import checkoutPaymentHtml from './checkoutpayment.component.html';
import './checkoutpayment.component.scss';

class CheckoutPaymentController {
    constructor($scope, $timeout, CheckoutService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.service = CheckoutService;
        this.showCountrySelect = false;
    }

    $onInit() {
        this.$scope.$watch(
            () => {
                if (!this.service.summary) return null;

                return this.service.summary;
            },
            (newSummary, oldSummary) => {
                if (!newSummary) return;
                if (!this.service.loaded || this.service.loading) return;

                // New checkout value -> refresh payments and shipments
                if (!oldSummary || (oldSummary && newSummary.value_of_products_with_discount != oldSummary.value_of_products_with_discount)) {
                    this.service.loadPayments();
                }
            },
            true
        );

        this.$scope.$watch(
            () => this.service.userLogged ? this.service.data.invoiceAddressId : this.service.data.invoiceAddress.invoice,
            () => {
                if (!this.service.paymentsFiltered) {
                    return;
                }
                if (!this.service.paymentsFiltered.find(payment => this.service.summary.payment_id === payment.id)) {
                    this.service.summary.payment_id = null;
                }
            }
        )
    }

    setPayment(payment) {
        this.service.setPayment(payment);
    }

    getCurrentPayment() {
        if (!this.service.summary.payment_id) return null;

        return this.service.payments.filter(payment => payment.id == this.service.summary.payment_id)[0];
    }
}

let checkoutPaymentComponent = {
    bindings: {},
    template: checkoutPaymentHtml,
    controller: CheckoutPaymentController
}

export default checkoutPaymentComponent;
